import { TDevice } from '@cian/utils';

import { selectFeature } from './selectFeature';
import { openSearchResultsSidebar } from '../../../common/actions/searchResults';
import { markAsViewed } from '../../../common/actions/viewed/markAsViewed';
import { TFeature } from '../../../common/types/map';
import { IApplicationState, TThunkAction } from '../../../common/types/redux';
import { convertBboxToString } from '../../../common/utils/convertBboxToString';

export interface IOpenFeatureParams {
  feature: TFeature;
  precision: number;
  isDetailed: boolean;
  deviceType: TDevice;
}

export function openFeature({ feature, precision, isDetailed }: IOpenFeatureParams): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(selectFeature(feature, precision));
    dispatch(openSearchResultsSidebar());

    if (!feature.properties.offers[0].isViewed) {
      dispatch(markAsViewed({ feature, precision, isDetailed }));
    }
  };
}

export function getFeatureQueryString(feature: TFeature, state: IApplicationState) {
  const { bbox: featureBBox } = feature.properties;
  const { queryString } = state;

  const bboxString = convertBboxToString(featureBBox);

  return `${queryString}&bbox=${bboxString}`;
}
